import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Email Triage</h1>
        <p>
          Efficiently manage and categorize your emails
        </p>
      </header>
    </div>
  );
}

export default App; 